import { render } from "./layout-header.vue?vue&type=template&id=78216139"
import script from "./layout-header.vue?vue&type=script&lang=ts"
export * from "./layout-header.vue?vue&type=script&lang=ts"

import "./layout-header.vue?vue&type=style&index=0&id=78216139&lang=less"
script.render = render

export default script